import actions from './actions'

export default function CompanysReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_COMPANY:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.SELECT_COMPANY:
      return {
        ...state,
        selected: action.payload,
        loading: false,
      }
    case actions.UNSELECT_COMPANY:
      return {
        ...state,
        selected: null,
        loading: false,
      }
    case actions.EDIT_COMPANY:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_COMPANY:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_COMPANY:
      return {
        ...state,
        editing: { companyID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_COMPANY_RECIEVED ||
      actions.UPDATE_COMPANY_RECIEVED ||
      actions.DELETE_COMPANY_RECIEVED:
      return {
        ...state,
        editing: { companyID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
